import script from "./ItemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemTable.vue?vue&type=script&setup=true&lang=js"

import "./ItemTable.vue?vue&type=style&index=0&id=95a8e296&lang=css"

const __exports__ = script;

export default __exports__